import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

const useStyles = createUseStyles((theme) => ({
    head: {
        fontWeight: theme.fontWeight.bold,
        textTransform: 'uppercase'
    },
    text: {
        fontWeight: theme.fontWeight.normal,
        textTransform: 'none',
        marginBottom: '2rem'
    }
}));

const UnderWriterCell = ({ underWriters }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const underWritersJson = underWriters && underWriters.toJSON();
    const getNodes = () => {
        return underWritersJson && Object.keys(underWritersJson).map((underWriterTitle) => {
            const content = underWritersJson[underWriterTitle];
            return (
                <div key={underWriterTitle} className={classNames(classes.head)}>
                    {underWriterTitle}
                    <div className={classNames(classes.text)}>
                        {content}
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            {
                getNodes()
            }
        </>
    );
};

UnderWriterCell.propTypes = {
    underWriters: PropTypes.object
};

export { UnderWriterCell };
